export const RESOURCES_PER_LIST_PAGE = 40;
export const RESOURCES_PER_CARD_PAGE = 24;

export const VIEW_TYPE_REPORT_BUILDER_KEY = 'report_builder_page_view_type_key';
export const VIEW_TYPE_EXPLORE_KEY = 'explore_page_view_type_key';
